export default __webpack_public_path__ + "static/media/manual-click-hover.0c8ef725.png";